import type Period from 'modules/attendance/store/models/Period'
import { Employees } from 'modules/employees/store/collections/employees'

export const periodEmployee = (period: Period, employees: Employees) => {
  const employee = employees.find({
    id: period.attributes.employee_id,
  })

  if (!employee) {
    throw Error(`Error finding employees with id = ${period.attributes.employee_id}`)
  }

  return employee
}
